import React, { useState, useEffect, useRef } from 'react';

export const ReadingProgressBar = ({ contentRef, onProgressChange }) => {
  const [progress, setProgress] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(() => {
        if (!contentRef?.current) return;
        const el = contentRef.current;
        const rect = el.getBoundingClientRect();
        const windowH = window.innerHeight;
        const contentTop = rect.top + window.scrollY;
        const contentHeight = el.offsetHeight;
        if (contentHeight <= 0) return;

        const scrolled = window.scrollY - contentTop + windowH * 0.3;
        const pct = Math.min(100, Math.max(0, (scrolled / contentHeight) * 100));
        setProgress(pct);
        if (onProgressChange) onProgressChange(pct);
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [contentRef, onProgressChange]);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-zinc-900/50"
      data-testid="reading-progress-bar"
    >
      <div
        className="h-full transition-[width] duration-150 ease-out"
        style={{
          width: `${progress}%`,
          background: progress >= 95
            ? 'linear-gradient(90deg, #22c55e, #4ade80)'
            : 'linear-gradient(90deg, #E63946, #00F0FF)',
        }}
      />
      {progress > 0 && progress < 100 && (
        <span
          className="absolute right-3 top-1 text-[10px] text-zinc-500 font-mono tracking-wider select-none pointer-events-none"
          data-testid="reading-progress-pct"
        >
          {Math.round(progress)}%
        </span>
      )}
    </div>
  );
};

export default ReadingProgressBar;
